import { useRef } from 'react'

/**
 * hook that returns true at mount time, then always false
 * @see https://usehooks-ts.com/react-hook/use-is-first-render
 */
const useIsFirstRender = () => {
  const isFirst = useRef(true)

  if (isFirst.current) {
    isFirst.current = false
    return true
  }

  return isFirst.current
}

export default useIsFirstRender
